import React, { useState, useEffect, useRef } from "react";
import { Box, Container, makeStyles, Button } from "@material-ui/core";
import Page from "src/component/Page";
import Slidernew from "./Slidernew";
import Videos from "./Videos";
import axios from "axios";
import ApiConfigs from "src/ApiConfig/ApiConfig";
// import { motion } from "framer-motion";
const useStyles = makeStyles((theme) => ({
  TabButtonsBox: {
    borderBottom: "0.5px solid #393939",
    marginBottom: "50px",
    position: "relative",
    zIndex: "999",
    [theme.breakpoints.down("xs")]: {
      marginBottom: "60px",
    },
    "& button": {
      color: "#fff",
      fontSize: "26px",
      minWidth: "240px",
      borderBottom: "2px solid transparent",
      borderRadius: "0",
      fontFamily: "'Good Times Rg', sans-serif",
      [theme.breakpoints.down("sm")]: {
        fontSize: "16px",
        minWidth: "140px",
      },
      "&.active": {
        color: "#fff",
        borderBottom: "2px solid #da4378",
        border: "10px solid",
        background:
          "linear-gradient(48.78deg, #fff -3.61%, #fff 20.77%, #fff 52.14%, #fff 88.94%)",
        borderTop: "0",
        borderLeft: "0",
        borderRight: "0",
        borderWidth: "2px",
        borderRadius: "0px",
        backgroundClip: "text",
        borderImageSlice: "1",
        borderImageSource:
          "linear-gradient(48.78deg, #FFB000 -3.61%, #FF564D 20.77%, #FF0098 52.14%, #5D00C1 88.94%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
      },
    },
  },
}));
export default function Tab() {
  const classes = useStyles();
  const [tabview, setTabView] = useState("VideosNews");
  const [IsLoading, setIsLoading] = useState(false);
  const [newsData, setNewsData] = useState([]);
  const getNewsDataApiHandler = async () => {
    try {
      setIsLoading(true);
      const response = await await axios({
        method: "GET",
        url: ApiConfigs.listNews,
        params: {
          mediaType: tabview === "TextNews" ? "TEXT" : "VIDEO",
          // search: search ? search : null,
          // fromDate: fromDate ? `${moment(fromDate)}` : null,
          // toDate: toDate ? `${moment(toDate)}` : null,
          // page: page,
          // limit: 10,
        },
      });
      if (response.data.statusCode === 200) {
        setNewsData(response.data?.result?.docs);
        // setNoOfPages(response?.data?.result?.pages);
        setIsLoading(false);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setNewsData([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getNewsDataApiHandler();
  }, [tabview]);

  return (
    <Page title="Fieres">
      <Container maxWidth="lg">
        <Box mt={5} mb={5} position="relative" style={{ zIndex: "999" }}>
          <Box className={classes.TabButtonsBox}>
            <Button
              className={tabview === "TextNews" ? "active" : " "}
              onClick={() => setTabView("TextNews")}
            >
              News
            </Button>
            <Button
              className={tabview === "VideosNews" ? "active" : " "}
              onClick={() => setTabView("VideosNews")}
            >
              Videos
            </Button>
          </Box>
        </Box>
        <Box className="TabButtonsContant">
          {tabview === "TextNews" ? (
            // <motion.div
            //   initial={{ opacity: 0, scale: 0.5 }}
            //   animate={{ opacity: 1, scale: 1 }}
            //   transition={{ duration: 0.5 }}
            // >
            <Slidernew
              newsData={
                newsData &&
                newsData?.filter((item) => item.mediaType === "TEXT")
              }
              IsLoading={IsLoading}
            />
          ) : (
            // </motion.div>
            ""
          )}
          {tabview === "VideosNews" ? (
            <Videos
              newsData={
                newsData &&
                newsData?.filter((item) => item.mediaType === "VIDEO")
              }
              IsLoading={IsLoading}
            />
          ) : (
            ""
          )}
        </Box>
      </Container>
    </Page>
  );
}
